export default (props, vars) => (e) =>
  vars?.['useref1']?.['current'].contains(e.target) && props?.['onClick']();
